import React from "react";
import { Redirect } from "react-router-dom";

// User profile
import UserProfile from "../pages/Authentication/UserProfile";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Registrationshanti from "../pages/Authentication/Add_New_Client";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import LockScreen from "../pages/Authentication/auth-lock-screen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartistChart from "../pages/Charts/ChartistChart";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ToastUIChart from "../pages/Charts/ToastUIChart";
import ChartsKnob from "../pages/Charts/charts-knob";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";

import ChangePasswordPage from "../pages/Authentication/ChangePassword";
// Cutomers
import cutomerList from "../pages/CustomerMangement/cutomerList";
import loyaltyPointReport from "../pages/CustomerMangement/loyaltyPointReport";

import MainMenuMaster from "../pages/MenuManagement/MainMenuMaster";
import SubMenuMaster from "../pages/MenuManagement/SubMenuMaster";
import ChildMenuMaster from "../pages/MenuManagement/ChildMenuMaster";

import customerList from "../pages/CustomerMangement/cutomerList";

import add_customer from "../pages/CustomerMangement/add_Customer";
import edit_customer from "../pages/CustomerMangement/editCustomer";

// =========shanti Jewellers================

// =======client-----------
import Add_New_Client from "../pages/ManageClients/Add_New_Client";
import View_Client from "../pages/ManageClients/View_Client";
import Editclient from "../pages/ManageClients/Editclient";
import Transactions from "../pages/ManageClients/Transactions";

// ===========offline Payment======

import Offline_payment from "../pages/OfflinePayment/Payment";
import OfflineAcknowledgement from "../pages/OfflinePayment/OfflineAcknowledgement";

// =========AddUSer================
import Userlist from "../pages/UserManagement/UserList";
import AddUser from "../pages/UserManagement/AddUser";

// ======CloseAccount======

import CloseAccount from "../pages/CloseAccount/CloseAccount";
import CloseAccountList from "../pages/CloseAccount/CloseAccountList";

// ======Client======
import ChitsDashboard from "../pages/Clients/ChitsDashboard";
import Chits from "../pages/Clients/Chits";
import ViewChitDetails from "../pages/Clients/ViewChitDetails";

import ApproveClient from "../pages/ManageClients/ApproveClient";
import TransactionReport from "../pages/Report/TransactionReport";

import Paymentfail from "../pages/Clients/Paymentfail";
import PaymentSuccess from "../pages/Clients/PaymentSuccess";

import GeneratePassword from "../pages/Clients/GeneratePassword";
import AddDailyGoldRate from "../pages/AddDailyGoldRate/AddDailyGoldRate";

const authProtectedRoutes = [
  { path: "/admin_dashboard", component: Dashboard },
  //Crypto
  //profile
  { path: "/profile", component: UserProfile },

  //Ecommerce

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },

  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/tui-charts", component: ToastUIChart },
  { path: "/charts-knob", component: ChartsKnob },

  // Tables
  { path: "/tables-basic", component: BasicTables },
  { path: "/tables-datatable", component: DatatableTables },
  { path: "/tables-responsive", component: ResponsiveTables },
  { path: "/tables-editable", component: EditableTables },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-advanced", component: FormAdvanced },
  { path: "/form-editors", component: FormEditors },
  { path: "/form-mask", component: FormMask },
  { path: "/form-repeater", component: FormRepeater },
  { path: "/form-uploads", component: FormUpload },
  { path: "/form-wizard", component: FormWizard },
  { path: "/form-validation", component: FormValidations },
  { path: "/form-xeditable", component: FormXeditable },

  // Customer Management
  { path: "/customer_managment", component: cutomerList },
  { path: "/loyaltyPointReport", component: loyaltyPointReport },
  // Order management

  // MenuMaster
  { path: "/mainMenuMaster", component: MainMenuMaster },
  { path: "/subMenuMaster", component: SubMenuMaster },
  { path: "/childMenuMaster", component: ChildMenuMaster },

  // this route should be at the end of all other routes
  // =====	Customer Managment ====
  { path: "/add_customer", component: add_customer },
  { path: "/editCustomer", component: edit_customer },
  { path: "/customermanagement", component: customerList },

  { path: "/GeneratePassword", component: GeneratePassword },
  { path: "/add_daily_gold_rate", component: AddDailyGoldRate },
  // ==========Shanti Jewellers========

  { path: "/add_new_client", component: Add_New_Client },
  { path: "/view_client", component: View_Client },
  { path: "/edit_client", component: Editclient },
  { path: "/transaction_list", component: Transactions },

  // ---------offline--------

  { path: "/offline_payment", component: Offline_payment },
  { path: "/offline_acknowledgement", component: OfflineAcknowledgement },

  // ---------offline--------

  { path: "/user_list", component: Userlist },
  { path: "/add_user", component: AddUser },

  { path: "/close_account", component: CloseAccount },
  { path: "/close_account_list", component: CloseAccountList },

  // ======client======

  { path: "/dashboard", component: ChitsDashboard },
  { path: "/approve_client", component: ApproveClient },
  { path: "/viewchitdetails/:chitid", component: ViewChitDetails },
  // { path: "/chits", component: Chits },
  { path: "/transactionReport", component: TransactionReport },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password-screen", component: ChangePasswordPage },
  { path: "/register", component: Register },

  // ================Successfull===============
  { path: "/paymentfail", component: Paymentfail },
  { path: "/paymentsuccessfull", component: PaymentSuccess },

  // Authentication Inner
  { path: "/pages-login", component: Login }, //Login1
  { path: "/pages-register", component: Register }, //Register1
  { path: "/pages-forgot-pwd", component: ForgetPwd }, //Forgetpwd1
  { path: "/auth-lock-screen", component: LockScreen }, //LockScreen

  { path: "/registration", component: Registrationshanti }, //Registration Page
];

export { authProtectedRoutes, publicRoutes };
